import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import Skeleton from '../Skeleton'
import VerticalStepper from '../VerticalStepper'
import useStepperData from './useStepperData'
import {
  NavigationProvider,
  useNavigateIfAvailable,
} from '../../hooks/useAppNavigation'

const Card = ({children}) => (
  <Box
    className="fs-unmask"
    bg="mld.neutral.0"
    color="mld.neutral.900"
    p="md"
    borderRadius="lg"
  >
    {children}
  </Box>
)

Card.propTypes = {
  children: PropTypes.node.isRequired,
}

const CashinStepperContent = () => {
  const {t} = useTranslation('cashinStepper')
  const {isLoading, cashinSteps, currentStep, completedAllSteps} =
    useStepperData()

  if (isLoading) {
    return (
      <Card>
        <Skeleton
          data-testid="cashin-stepper-skeleton-loader"
          minHeight="200px"
        />
      </Card>
    )
  }

  // Setup is finished, so the checklist has nothing left to ask for and comes
  // off the dashboard. Completion is recalculated whenever the stepper data is
  // refreshed, so finishing the last step clears the checklist without the
  // supplier having to reload the page.
  if (completedAllSteps) {
    return null
  }

  return (
    <Card>
      <VerticalStepper
        title={t('title')}
        subtitle={t('subtitle')}
        steps={cashinSteps}
        currentStep={currentStep}
      />
    </Card>
  )
}

const CashinStepper = () => {
  const navigate = useNavigateIfAvailable()

  return (
    <NavigationProvider navigate={navigate}>
      <CashinStepperContent />
    </NavigationProvider>
  )
}

export default CashinStepper
